/* eslint-disable @next/next/no-img-element */
import { ASSETS } from 'src/common/utils/config';
import { ICard } from '../../../../interfaces';
import styles from './styles.module.scss';

const Index = ({
  code,
  name,
  sub_title,
  price,
  image_url,
  evisa,
  handleClick,
}: ICard) => {
  const currencyFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  });
  const numericPrice = Number(price?.slice(2));

  return (
    <section className={styles.cardContainer} onClick={() => handleClick(code)}>
      <div
        className={styles.imageContainer}
        style={{
          backgroundImage: `url(${image_url})`,
        }}
      >
        {evisa && (
          <div className={styles.evisaTag}>
            <img
              src={ASSETS.EVISA}
              width={'28px'}
              height={'28px'}
              alt="e-visa-tag"
            />
          </div>
        )}
      </div>
      <section className={styles.content}>
        <div className={styles.cardTitle}>{name}</div>
        <div className={styles.cardSubtitle}>{sub_title}</div>
        <div className={styles.priceSection}>
          <div className={styles.priceTitle}>{'Starting from'}</div>
          <div className={styles.priceValue}>
            {!!numericPrice ? currencyFormatter?.format(numericPrice) : price}
          </div>
        </div>
        <div className={styles.borderContainer}>
          <div
            className={styles.borderImage}
            style={{
              background: `url(${ASSETS.V2F_CARD_BORDER})`,
            }}
          />
        </div>
      </section>
    </section>
  );
};

export default Index;
